
import React, { Component } from 'react';
import { Modal, Form, Input, Switch, Row, Col } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import validator from '../../../util/validator';
import OrgSelect from '../../ui/OrgSelect';


const fields = [{
    "text": "所属市场",
    "field": "orgCode",
    org: true,
    rules: [
        { required: true, message: '所属市场不能为空!' },
    ]
}
, {
    "text": "会员名称",
    "field": "name",
    rules: [
        { required: true, message: '会员名称不能为空!' },
        { max: 32, message: '会员名不能超过32个字符！' },
    ]
}
, {
    "text": "竞价会员编号",
    "field": "abbreviation",
    rules: [
        { max: 32, message: '竞价会员编号不能超过32个字符！' },
    ]
}
, {
    "text": "证件号码",
    "field": "creditNo",
    rules: [
        { required: true, message: '证件号码不能为空!' },
        // { max: 32, message: '证件号码不能超过32个字符！' },
        validator.creditNo
    ]
}
,{
    "text": "中文简称",
    "field": "abbreviationCN",
    rules: [
        { max: 32, message: '中文简称不能超过32个字符！' }
    ]
}
,{
    "text": "英文简称",
    "field": "abbreviationEN",
    rules: [
        { max: 32, message: '英文简称不能超过32个字符！' },
    ]
}
,{
    "text": "地址",
    "field": "address",
    rules: [
        { required: true, message: '地址不能为空!' },
        { max: 64, message: '地址不能超过64个字符！' },
    ]
}
,{
    "text": "联系人",
    "field": "contactMan",
    rules: [
        { required: true, message: '联系人不能为空!' },
        { max: 16, message: '联系人不能超过64个字符！' },
    ]
}
,{
    "text": "联系人证件号",
    "field": "contactManCreditNo",
    rules: [
        validator.creditNo
    ]
}
,{
    "text": "联系电话",
    "field": "contactNumber",
    rules: [
        { required: true, message: '联系电话不能为空!' },
        validator.tel
    ]
}
,{
    "text": "是否租户",
    "field": "tenant",
    radio: true
}
,{
    "text": "三号地租户",
    "field": "threeTenant",
    radio: true
}, {
    "text": "是否代办",
    "field": "agent",
    radio: true
}, {
    "text": "是否商城会员",
    "field": "mall",
    radio: true
}, {
    "text": "是否竞价会员",
    "field": "auction",
    radio: true
}, {
    "text": "是否柏亿会员",
    "field": "baiYi",
    radio: true
}];


class MemberEditForm extends Component {

    state = {}

    save = () => {
        const form = this.props.form;
        const optionKeys = ['tenant', 'threeTenant', 'agent', 'mall', 'auction', 'baiYi'];

        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            let code = this.props.editData.code
            if (code !== undefined && code != null) {
                values["code"] = code;
            }
            fields.forEach((json, index) => {
                if (json["radio"] === true) {
                    values[json["field"]] = values[json["field"]] ? 1 : 0;
                }
            })
            const hasSelected = optionKeys.some(key => Number(values[key]) === 1);

            if (!hasSelected) {
                messager.notify("至少选择一个会员类型！");
                return
            }
            // values["tenant"] = values["tenant"] ? 1:0;
            // values["agent"] = values["agent"] ? 1:0;
            // values["mall"] = values["mall"] ? 1:0;
            http.post({
                url: '/member/saveMember',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: item.radio ? editData[item.field] === 1 : editData[item.field],
                            valuePropName: item.radio ? 'checked' : 'value'
                        })(
                            item.radio ?
                                <Switch checkedChildren="是" unCheckedChildren="否" />
                                : item.org ? <OrgSelect orgType={4} />
                                    : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    create2Col = (fields) => {
        let dom = this.createDom(fields);
        let result = [];
        for (let i = 0; i < dom.length; i++) {
            let item = <Col key={i} span={11} offset={i % 2 === 0 ? 0 : 2}>{dom[i]}</Col>;
            result.push(item);
        }
        return result;
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="会员信息编辑"
                width={800}
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Row>{this.create2Col(fields)}</Row>
                </Form>
            </Modal>
        );
    }
}

const MemberEdit = Form.create()(MemberEditForm);

export default MemberEdit;
